'use strict';
import angular from 'angular';
import bridgeEmailTestHtmlUrl from './views/bridgeEmailTest.html';
import _ from "lodash";

var app = angular.module('app.bridgeEmailTest', []);

app.component('bridgeEmailTest', {
    bindings: {
        bridgeEmailTest: '=',
        showActions : '=',
        formContentTypeId : '<',
        entireFlight : '<',
        entireLineItem : '<',
        clientId : '<',
    },
    templateUrl: bridgeEmailTestHtmlUrl,

    controller: function($scope, $ioAlert, $rootScope, FormService) {
        var self = this;
        self.dataObj = null;
        $scope.comments = {};
        $scope.initialAsyncValues = {};

        self.sendTestToBridge = function() {
            // Once clicked, set disabled=true until successful callbacks are received.
            self.isDisabled = true;
            $scope.isWaitingForCallbackAfterClick = true;
            // This will handle both API calls since the validateSeedListPurple callback calls emailTestPurple.
            FormService.validateSeedListPurple(self.bridgeEmailTest).then(function(response) {
                if (response.status == 200) {
                    $ioAlert.show('Success!', 'The email test process has been successfully started.', 'success');
                    // Send event so that the line item/flight component in lineitems.ctrls.js can refresh comments.
                    $rootScope.$broadcast('bridgeEmailTestSent');
                } else {
                    $ioAlert.show('Error!', 'An error occurred, please try again.', 'error');
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function extractAsyncValues() {
            if (self.entireFlight) {
                $scope.asyncValues = FormService.extractAsynchronousFieldValues(self.entireFlight);
            } else {
                $scope.asyncValues = FormService.extractAsynchronousFieldValues(self.entireLineItem);
            }
            //console.log($scope.asyncValues);

            if ($scope.isWaitingForCallbackAfterClick) {
                if ($scope.asyncValues.__seed_validation_status == "success") {
                    $ioAlert.show('Success!', 'Seed Validation Success! Sending Email Test Data to BridgeCorp Now.', 'success');
                }
                if ($scope.asyncValues.__email_test__validation_status == "success") {
                    $ioAlert.show('Success!', 'Email Test Callback was successfully received! Refreshing Page.', 'success');
                    self.isDisabled = false;
                    $scope.isWaitingForCallbackAfterClick = false;
                }
            }
        }

        function newDataObj() {
            let dataObj = {};
            // Necessary Seed List Validation Fields
            dataObj.seedListFileValues = null;
            dataObj.creative_id = null;
            dataObj.field_delimiter = null;
            dataObj.column_separator = null;
            return dataObj;
        }

        self.initComponent = function() {
            if (self.bridgeEmailTest) {
                self.dataObj = newDataObj();
                $scope.isWaitingForCallbackAfterClick = false; // Set to false if we haven't clicked the button when loading the component.
                if (self.showActions) {
                    self.isDisabled = true;
                } else {
                    if (self.entireFlight) {
                        if (self.entireFlight.__html_validation_status == 'success' &&
                            self.entireFlight.__test_seed_validation_status != 'processing' &&
                            self.entireFlight.__email_test_validation_status != 'processing' &&
                            self.entireFlight.__creative_id &&
                            (!self.entireFlight.__has_critical_html_val_errors || self.entireFlight.__has_critical_html_val_errors == "0") &&
                            self.entireFlight.__test_seed_validation_file_uri &&
                            $scope.isWaitingForCallbackAfterClick == false
                        ) {
                            extractAsyncValues();
                            self.isDisabled = false;
                            self.dataObj.seedListFileValues = self.entireFlight.__test_seed_validation_file_uri;
                            self.dataObj.creative_id = self.entireFlight.__creative_id;
                            self.dataObj.field_delimiter = self.entireFlight.__field_delimiter;
                            self.dataObj.column_separator = self.entireFlight.__column_separator;
                            self.bridgeEmailTest = {'seed_data': self.dataObj, 'flight_id': self.entireFlight.id};
                        } else {
                            // If all conditions aren't met then button should not be actionable.
                            self.isDisabled = true;
                        }
                    } else if (self.entireLineItem) {
                        if (self.entireLineItem.__html_validation_status == 'success' &&
                            self.entireLineItem.__test_seed_validation_status != 'processing' &&
                            self.entireLineItem.__email_test_validation_status != 'processing' &&
                            self.entireLineItem.__creative_id &&
                            (!self.entireLineItem.__has_critical_html_val_errors || self.entireLineItem.__has_critical_html_val_errors == "0") &&
                            self.entireLineItem.__test_seed_validation_file_uri &&
                            $scope.isWaitingForCallbackAfterClick == false
                        ) {
                            extractAsyncValues();
                            self.isDisabled = false;
                            self.dataObj.seedListFileValues = self.entireLineItem.__test_seed_validation_file_uri;
                            self.dataObj.creative_id = self.entireLineItem.__creative_id;
                            self.dataObj.field_delimiter = self.entireLineItem.__field_delimiter;
                            self.dataObj.column_separator = self.entireLineItem.__column_separator;
                            self.bridgeEmailTest = {'seed_data': self.dataObj, 'line_item_id': self.entireLineItem.id};
                        } else {
                            // If all conditions aren't met then button should not be actionable.
                            self.isDisabled = true;
                        }
                    }
                }
            } else {
                self.bridgeEmailTest = {};
                // Always should be disabled in a create/edit mode.
                self.isDisabled = true;
            }
        }

        self.initComponent();
    }
});